import { app } from '../../../bootstrap/core';
import appHeaderComponent from './appHeader.component';

app.component('appHeader', appHeaderComponent);



// WEBPACK FOOTER //
// ./src/app/common/ui/appHeader/appHeader.js